<template>
  <v-container>
    <v-layout row
      text-xs-center
      wrap
    >
    <v-flex
            grow
            pa-1
          >
    <v-select
    v-model="form.event"
    @change="change"
           :items="events"
           label="Choisissez votre évènement"
           :item-text="itemText"
          return-object
         ></v-select>
</v-flex>
 </v-layout>
<v-layout row
  text-xs-center
  wrap
>
<v-flex
        grow
        pa-1
      >
      <v-autocomplete v-show="runners.length > 0"
        v-model="form.runner"
        :items="runners"
        :item-text="itemRunner"
       return-object
       label="Choisissez un participant"
       @change="selectRunners"

      >
      </v-autocomplete>

              </v-flex>
     </v-layout>

     <v-layout row
       text-xs-center
       wrap
     >
     <v-flex
             grow
             pa-1
           >
     <v-select
     v-show="radio_controls.length > 0"
          v-model="form.radio_controls"
          :items="radio_controls"
          :menu-props="{ maxHeight: '400' }"
          label="Choisisseez le ou les postes radios"
          multiple
          :item-text="itemRadio"
          persistent-hint
        ></v-select>
      </v-flex>
</v-layout>
<v-btn @click="go" :disabled="form.radio_controls.length == 0" type="submit" block color="primary" dark>C'est parti ! </v-btn>

  </v-container>
</template>

<script>
  const events = require("../assets/data/events.json")

  export default {
    data: () => ({
      hubUrl: 'https://hubmercure.o-club.net/hub',
      baseUrl: 'https://livePunches.oclub.net',
      events: events,
      runners: [],
      form: {radio_controls: [],event: '', runner: ''},
      radio_controls: []
    }),
    mounted() {

      Notification.requestPermission((p) => {
        if(!('permission' in Notification)) {
          Notification.permission = p
        }
      })
    },
    methods: {
      selectRunners () {
        this.radio_controls = []
        let controls = require('../assets/data/' + this.form.event.si_id +'/courses.json').filter(r => r.name ==  this.form.runner.class)
        if (controls.length > 0) {
          this.radio_controls = controls[0].radio_controls
        }
      },
      go () {

        var radios= []
        this.form.radio_controls.forEach((r) => {
            radios.push(this.baseUrl+'/events/'+ this.form.event.si_id +'/'+this.form.runner.sicard+'/'+r+'/')
        })
        console.log(radios)
        //const eventSource = new EventSource(url);
        var o = {'runner': this.form.runner, 'event':this.form.event, 'hubUrl': this.hubUrl, 'radioControls': radios}
        navigator.serviceWorker.controller.postMessage(o);

      },
      change(e) {
        this.runners = []
        this.runners = require('../assets/data/' + e.si_id +'/runners.json')
      },
      itemRadio (r) {
        return r.control
      },
      itemRunner (i) {
        return i.bib + ' / '+ i.firstname + ' ' + i.name + ' ('+ i.sicard+')'
      },
      itemText (i) {
        return i.name +' (' + i.date + ')'
      }
    }
  }
</script>

<style>

</style>
